import React from 'react';
import { Filter, TextInput } from 'react-admin';

const CurrentProductsReportsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Product name" source="name" alwaysOn />
  </Filter>
);

export default CurrentProductsReportsFilter;
